import { RegistryWidgetsType } from '@rjsf/utils';
import { SelectWidget } from './select';
import { CheckboxWidget } from './checkbox';

export const widgets: RegistryWidgetsType = {
  SelectWidget,
  CheckboxWidget,
};
